export const LOGIN_CARD = {
    TITLE: 'Sign in',
};
